import { auth } from './lib/firebase/firebase.js';
import { validate, emailValidator, passwordValidator } from './lib/validator.js';
import {checkIfLoggedIn, authorizedRoute} from './lib/auth.js';

checkIfLoggedIn();

let loginForm = document.getElementById("login");

loginForm.addEventListener("submit", async (e) => {
    e.preventDefault();

    let email = document.getElementById("email");
    let password = document.getElementById("password");

    let loginButton = document.getElementById("login-button");
    

    let formElements = [
        {
            field: email,
            validator: emailValidator,
            error_label: "email_error_label"
        },
        {
            field: password,
            validator: passwordValidator,
            error_label: "password_error_label"

        },
    ];

    if (validate(formElements)) {
        loginButton.textContent = "Signing in...";
        loginButton.disabled = true;

        try {
            let result = await auth.signInWithEmailAndPassword((email.value).trim(), password.value);

            let claims = (await result.user.getIdTokenResult()).claims;

            if (claims.admin || claims.staff) {
                await Swal.fire({
                    icon: 'success',
                    title: 'Logged In',
                    text: 'You will be redirected shortly',
                });
                sessionStorage.loggedIn = "true";
                window.location.href = authorizedRoute;

                loginButton.textContent = "Sign In";
                loginButton.disabled = false;


            }
            else {
                await auth.signOut();

                await Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Unauthorized',
                });

                loginButton.textContent = "Sign In";
                loginButton.disabled = false;


            }
        }
        catch (error) {
            await Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Invalid Password',
            });

            console.log(error.message);

            loginButton.textContent = "Sign In";
            loginButton.disabled = false;


        }

    }
    
});




